// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-portfolio----projects-module---container---2UrIY","cell":"src-components-portfolio----projects-module---cell---3wlDQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/projects.module.scss
// module id = 368
// module chunks = 36434998819415 120690779865315